module.exports = __webpack_public_path__ + "img/lighting-repair-replacement-01-square.d8b4eb57.jpg";